var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcLogout = function SvgIcLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.493 9.833 7.576 11.74a.833.833 0 0 0 0 1.183.833.833 0 0 0 1.184 0l3.333-3.333a.835.835 0 0 0 .175-.275.834.834 0 0 0 0-.633.835.835 0 0 0-.175-.275L8.76 5.074a.837.837 0 1 0-1.184 1.184l1.917 1.908H1.501a.833.833 0 0 0 0 1.667h7.992ZM9.001.666a8.333 8.333 0 0 0-7.5 4.625.839.839 0 0 0 1.5.75 6.667 6.667 0 1 1 6 9.625 6.608 6.608 0 0 1-5.966-3.708.839.839 0 1 0-1.5.75A8.333 8.333 0 1 0 9 .666Z",
    fill: "#ADADAD"
  })));
};
export default SvgIcLogout;